import BaseLayout from "layouts/base-layout";
import React, { useContext } from "react";
import MetaTags from "@root/components/meta";
import { getCategory, getCategoryProducts } from "@root/pms/category";
import { CategoryProvider } from "@root/context/category";
import RenderModules from "@helpers/render-modules";
import { DynamicContentProvider } from "@root/context/dynamic-content";
import { truncate } from "lodash";

const CategoryLanding = ({ pageContext, serverData, location: { pathname } }) => {
    const { settings, template, page } = pageContext;
    const { baseCategory, currentCategory, currentCategoryProducts } = serverData;

    const pageData = page ?? pageContext?.category;

    return (
        <BaseLayout settings={settings} path={pathname}>
            <CategoryProvider pageData={pageData} baseCategory={baseCategory} currentCategory={currentCategory} currentCategoryProducts={currentCategoryProducts?.products}>
                <DynamicContentProvider>
                    <div className={template === "other" ? "container" : ""}>
                        <div className={template === "other" ? "container--other-pages" : ""}>
                            {pageData?.modules && <RenderModules modules={pageData?.modules} />}
                        </div>
                    </div>
                </DynamicContentProvider>
            </CategoryProvider>
        </BaseLayout>
    );
};

export async function getServerData({ params, pageContext }) {
    const { page } = pageContext;
    const { handle } = params;

    const pageData = page ?? pageContext?.category;

    try {
        /* eslint-disable prefer-const */

        // eslint-disable-next-line no-console
        // console.time(`fetching category ${pageData.categorySlug}`);

        let baseCategory;
        let baseCategoryHeaders;
        let currentCategory;
        let currentCategoryHeaders;
        let currentCategoryProducts;

        ({ data: baseCategory, headers: baseCategoryHeaders } = await getCategory(pageData.categorySlug, { hierarchy: true }));
        ({ data: currentCategory, headers: currentCategoryHeaders } = await getCategory(handle || pageData.categorySlug, { hierarchy: false }));

        ({ data: currentCategoryProducts } = await getCategoryProducts(handle || pageData.categorySlug));

        let headers = currentCategoryHeaders ?? baseCategoryHeaders;

        return {
            props: {
                baseCategory, currentCategory, currentCategoryProducts,
            },
            headers: {
                "Netlify-CDN-Cache-Control": "no-cache",
                "Cache-Control": "public, max-age=300",
                etag: headers?.etag,
            },
            multiValueHeaders: { "last-modified": headers?.["last-modified"] ? [headers?.["last-modified"]] : undefined },
        };
    } catch (err) {
        if (err.response.status === 404) {
            return {
                status: 404, props: {}, headers: {},
            };
        }
        throw new Error(err.message);
    } finally {
        // eslint-disable-next-line no-console
        // console.timeEnd(`fetching category ${pageData.categorySlug}`);
    }
}

const setExtraMeta = (handle) => [
    {
        type: "link",
        content: <link
            key="canonical-link"
            rel="canonical"
            href={`https://sealskincovers.com/${handle}`}
        />,
    },
];

export const Head = ({ serverData, pageContext }) => {
    try {
        let defaultMeta = {
            title: serverData?.currentCategory?.meta?.title || serverData?.currentCategory?.name || "",
            description: serverData?.currentCategory?.meta?.description || truncate(serverData?.currentCategory?.description?.replace(/<\/?[^>]+>/g, "") || "", {
                length: 160, separator: " ", omission: "...",
            }) || "",
        };

        let handle = serverData?.baseCategory?.slug;
        if (serverData?.baseCategory?.slug !== serverData?.currentCategory?.slug) {
            handle = `${serverData?.baseCategory?.slug}/${serverData?.currentCategory?.slug}`;
        }
        let extras = setExtraMeta(handle);

        return <MetaTags meta={defaultMeta} extra={extras} />;
    } catch (err) {
        return null;
    }
};
export default CategoryLanding;
